import { PROVIDERS_PAGE_SIZE_OPTIONS } from '../../constants/pagination';

function formatDisplayedRows(info: { from: number; to: number; count: number }) {
  return `${info.from}–${info.to} sur ${info.count}`;
}

function getItemAriaLabel(type: string) {
  return type === 'next' ? 'Page suivante' : 'Page précédente';
}

type Props = {
  count: number;
  /** 0-based. */
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
};

export function useProvidersPagination(props: Props) {
  const totalPages = Math.ceil(props.count / props.rowsPerPage);
  const isFirstPage = props.page === 0;
  const isLastPage = props.page >= Math.max(0, totalPages - 1);
  const mobilePageLabel = `Page ${props.page + 1} sur ${Math.max(1, totalPages)}`;

  function handlePrevious() {
    if (!isFirstPage) {
      props.onPageChange(props.page - 1);
    }
  }

  function handleNext() {
    if (!isLastPage) {
      props.onPageChange(props.page + 1);
    }
  }

  return {
    rowsPerPageOptions: PROVIDERS_PAGE_SIZE_OPTIONS,
    formatDisplayedRows,
    getItemAriaLabel,
    isFirstPage,
    isLastPage,
    mobilePageLabel,
    handlePrevious,
    handleNext,
  };
}
